module.exports = __webpack_public_path__ + "static/card-winalot-review1-v2-a8092f9bdf041a3378a7ebff66c5d880.png";